import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { App, LoadingController, ModalController, NavController, ToastController } from 'ionic-angular';
import { EventProvider, RouteInfos } from '../../providers/event/event';
import { LeafletCreator, MapHandlerCreator } from '../../tracker/map-factory/map-factory';
import { StrackerPage } from '../../tracker/sencha-tracker/stracker';
import { LocationHandlerUtil } from '../../tracker/location-handler-utils';
import { StorageProvider } from '../../providers/storage-service/storage-service';
import L from 'leaflet';
import 'leaflet.offline';
import { SessionProvider } from '../../providers/session/session';
import { MysportPhotosPage } from '../../pages/me/mysport/mysport-photos/mysport-photos';
import { ParticipantListComponent } from '../participant-list/participant-list';
import { UserProvider } from '../../providers/user/user';

declare var google;

@Component({
	selector: 'my-routes-component',
	templateUrl: 'my-routes-component.html'
})
export class MyRoutesComponent {
	routes;
	urlTemplate = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
	noActivitiesMessage:string='';
	constructor(
		private eventService: EventProvider,
		private translate: TranslateService,
		private toastCtrl: ToastController,
		private navCtrl: NavController,
		private app: App,
		private storageService: StorageProvider,
		private sessionService: SessionProvider,
		private loadCtrl: LoadingController,
		private modalCtrl: ModalController,
		private userService: UserProvider
	) {
		this.init();
		// this.noActivitiesMessage = this.translate.instant('NO_PLANNED_ROUTES');
	}

	init() {
		this.getRoutes().then(routes => {
			this.sessionService.getToken().then(token => {
				if (!routes) {
					this.noActivitiesMessage = this.translate.instant('NO_PLANNED_ROUTES');
					// this.showToast(this.translate.instant('MY_ROUTES_NULL_CASE'));
					// this.navCtrl.pop();
				} else {
					this.routes = routes.filter(r => r.routeData.length > 0);
					for (let i = 0; i < this.routes.length; i++) {
						this.routes[i].baseLayer = null;
						this.routes[i].map = null;
						this.routes[i].control = null;
						this.routes[i].id = "leaflet" + i + new Date().getTime();
					}
					setTimeout(() => {
						for (let i = 0; i < this.routes.length; i++) {
							// if (!!this.routes[i].distance && !!this.routes[i].altitude) {
							this.loadLeafletMaps(this.routes[i].id, i).then(() => {
								this.routes[i].altitude = 0;
								this.routes[i].mapHandler = new LeafletCreator(this.routes[i].map);
								this.routes[i].path = this.retrieveRoute(this.routes[i]);
								LocationHandlerUtil.assignAltitude(this.routes[i].path, this.eventService, token).then((results:any) => {
									if (results && typeof results[0] != "undefined") {
										// this.routes[i].altitude = Math.floor(LocationHandlerUtil.calcAltitude(results.map((r) => r["results"][0].elevation)));
										let elevation = 0;
										let diff = 0;
										for (let i = 0; i < results.length; i++) {
											for (let j = 0; j < results[i].length - 1; j++) {
												diff = results[i][j + 1] - results[i][j];
												if (diff > 0) {
													elevation += diff;
												}
											}
										}
										this.routes[i].altitude = elevation;
									}
								});
								this.routes[i].distance = this.calculateDistance(this.routes[i].path);
								this.drawLines(this.routes[i]);
								this.boundLeaflet(this.routes[i]);
							});
							// }
						}
					}, 400);
				}
			});
		});
	}

	calculateAltitude(path) {

	}

	calculateDistance(path) {
		return LocationHandlerUtil.calcPathDistance(path);
	}

	boundLeaflet(route) {
		let markerArray = [];
		for (let i = 0; i < route.path.length; i++) {
			markerArray.push(L.marker([route.path[i].lat(), route.path[i].lng()]));
		}
		let center = route.mapHandler.getCenter();
		markerArray.push(L.marker([center.lat, center.lng]));
		let group = L.featureGroup(markerArray);
		route.map.fitBounds(group.getBounds());
	}

	retrieveRoute(route) {
		let fullPath = [];
		let data;

		try {
			data = JSON.parse(route.routeData) as RouteInfos;
			data.routeInfos.forEach(info => {
				fullPath = fullPath.concat(google.maps.geometry.encoding.decodePath(info.path));
			});
		} catch (err) {
			console.log(err);
		}

		return fullPath.slice();
	}

	drawLines(route) {
		if (!route.path.length) return;
		route.mapHandler.newPoly();
		route.mapHandler.setPolyDestinations(route.path);
		route.mapHandler.drawPolyLines(true);
		route.mapHandler.setMapCenterLatLng(route.path[0]);
	}

	getRoutes(): Promise<any> {
		return new Promise<any>((resolve, reject) => {
			this.eventService.getMyRoutes().then(routes => resolve(routes));
		});
	}

	showToast(message: string) {
		this.toastCtrl.create({
			message: message,
			position: 'top',
			duration: 5000
		}).present();
	}

	loadLeafletMaps(id, index) {
		return new Promise<any>((resolve, reject) => {
			let map = (L as any).map(id);

			let baseLayer = (L as any).tileLayer
				.offline(this.urlTemplate, {
					attribution: 'Map data {attribution.OpenStreetMap}',
					subdomains: 'abc',
					minZoom: 1,
				})
				.addTo(map);

			map.setView(
				{
					lat: 52.5204345,
					lng: 13.4014027,
				},
				19
			);

			let that = this;
			let control = (L as any).control.savetiles(baseLayer, {
				zoomlevels: [19, 19], // optional zoomlevels to save, default current zoomlevel
				confirm(layer, successCallback) {
					console.log('layer: ', layer);
					successCallback();
				},
				confirmRemoval(layer, successCallback) {
					if (window.confirm('Remove all the tiles?')) {
						successCallback();
					}
				},
				saveText:
					'<i class="fa fa-download" aria-hidden="true" title="Save tiles"></i>',
				rmText: '<i class="fa fa-trash" aria-hidden="true"  title="Remove tiles"></i>',
			});
			control.addTo(map);

			let progress;
			baseLayer.on('savestart', (e) => {
				console.log('e: ', e);
				progress = 0;
				console.log(e._tilesforSave.length);
			});
			baseLayer.on('savetileend', () => {
				progress += 1;
				console.log("progress: " + progress);
			});

			this.routes[index].map = map;
			this.routes[index].baseLayer = baseLayer;
			this.routes[index].control = control;

			resolve(null);
		});
	}

	onRedirectGallery(r) {
		let loader = this.loadCtrl.create({});
		loader.present();
		this.sessionService.getToken().then(token => {
			this.eventService.getRoutePrics(token, r.routeName).then((pics) => {
				loader.dismiss();
				let type = (pics.length > 0) ? "route-image" : "route-no-pics";
				this.navCtrl.push(MysportPhotosPage, { pictures: pics, type: type, routeName: r.routeName });
			});
		});
	}

	onParticipantList() {
		let modal = this.modalCtrl.create(ParticipantListComponent);
		modal.present();

		modal.onDidDismiss((patricipant) => {
			if (patricipant) this.addFriend(patricipant);
		});
	}

	addFriend(patricipant) {
		var loader = this.loadCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
		loader.present();
		this.userService.addFriend(patricipant.lid).then(friendList => {
			loader.dismiss()
		});
	}


	async onRedirectTracker(r) {
		let event = {
			cid: -1,
			id: -1,
			name: "",
			streckeconv: r.distance + "",
			eventStatus: "route"
		};

		let route = {
			hasRoute: true,
			fullPath: r.path
		};

		(this.app.getRootNav() as NavController).push(StrackerPage, { event: event, route: route })
	}
}



// WEBPACK FOOTER //
// /src/components/my-routes/my-routes-component.ts